export { default as Spacer } from './Spacer';
export type { SpacerProps } from './types';
